// Request schemas of Einstellungen → Team & Einladungen (spec §1.11, §1.12).
import { z } from 'zod'

export const invoicePrefixSchema = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^[A-Z][A-Z0-9]{1,7}$/, 'Rechnungspräfix: 2–8 Zeichen aus A–Z und 0–9, beginnend mit einem Buchstaben.')

export const createTeamMemberSchema = z.object({
  display_name: z.string().trim().min(1, 'Name fehlt.').max(120),
  short_code: z.string().trim().max(40).optional(),
  invoice_prefix: invoicePrefixSchema.optional(),
  legacy_name: z.string().trim().max(120).nullish(),
})
export type CreateTeamMemberBody = z.infer<typeof createTeamMemberSchema>

export const patchTeamMemberSchema = z
  .object({
    display_name: z.string().trim().min(1).max(120),
    short_code: z.string().trim().min(1).max(40),
    legacy_name: z.string().trim().max(120).nullable(),
    active: z.boolean(),
    invoice_prefix: invoicePrefixSchema,
  })
  .partial()
  .refine((patch) => Object.keys(patch).length > 0, { message: 'Es wurde nichts geändert.' })
export type PatchTeamMemberBody = z.infer<typeof patchTeamMemberSchema>

export const inviteTeamMemberSchema = z.object({
  email: z.string().trim().max(200).email('Bitte eine gültige E-Mail-Adresse angeben.'),
})
export type InviteTeamMemberBody = z.infer<typeof inviteTeamMemberSchema>
